export const MAP_ROUTE = '/map';
export const COURIERS_ROUTE = '/couriers';
export const ADD_COURIER_ROUTE = '/couriers/add';
export const LOGIN_ROUTE = '/';
export const EDIT_ROUTE = '/edit';
export const ADD_PRODUCT = '/products/add';
export const SHIPMENT_STATISTICS = '/shipment-statistics';
